import { useTranslation } from 'react-i18next'
import type { QuickSuggestionProps } from '@brochure/shared'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className="px-3.5 py-2 text-xs font-medium bg-white hover:bg-maia-warm text-ink rounded-full transition-colors disabled:opacity-50 shadow-sm border border-cord/50 hover:border-maia/40"
        >
          {t(suggestion.labelKey)}
        </button>
      ))}
    </div>
  )
}
